import axios from 'axios';
import { authHeader2 } from '@/helper/authHeader';

const API_URL = process.env.API_URL;

export async function getList() {
  const url = `${API_URL}/admin/video/section/list`;
  return axios({ url,
    method: 'get',
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function searchVideo(params) {
  const url = `${API_URL}/admin/video/section/search-video`;
  return axios({ url,
    method: 'get',
    params,
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getDetail(id) {
  const url = `${API_URL}/admin/video/section/detail/${id}`;
  return axios({ url,
    method: 'get',
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function create(data) {
  const url = `${API_URL}/admin/video/section/create`;
  return axios({ url,
    method: 'post',
    data,
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function update(data) {
  const url = `${API_URL}/admin/video/section/update`;
  return axios({ url,
    method: 'post',
    data,
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function deleteSection(data) {
  const url = `${API_URL}/admin/video/section/delete`;
  return axios({ url,
    method: 'post',
    data,
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function reorderSection(data) {
  const url = `${API_URL}/admin/video/section/re-order`;
  return axios({ url,
    method: 'post',
    data,
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function publishSection(data) {
  const url = `${API_URL}/admin/video/section/set-publish`;
  return axios({ url,
    method: 'post',
    data,
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function addContent(data) {
  const url = `${API_URL}/admin/video/section/add-video`;
  return axios({ url,
    method: 'post',
    data,
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function reorderContent(sectionId, data) {
  const url = `${API_URL}/admin/app-setting/home-section/${sectionId}/content/re-order`;
  return axios({ url,
    method: 'post',
    data,
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}



// WEBPACK FOOTER //
// ./src/services/videopage.js